<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.7774 15.7779C20.3479 16.2075 19.6514 16.2075 19.2218 15.7779L11.9996 8.55573L4.77743 15.7779C4.34785 16.2075 3.65137 16.2075 3.22179 15.7779C2.79222 15.3483 2.79222 14.6519 3.22179 14.2223L11.2218 6.22228C11.6514 5.7927 12.3479 5.7927 12.7774 6.22228L20.7774 14.2223C21.207 14.6519 21.207 15.3483 20.7774 15.7779Z" fill="#333333"/>
    </svg>
</template>
<script>
    export default {
        name: 'DropdownArrowIcon'
    };
</script>